import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { TEXT } from '../../shared/styles/colors';

export const Text = styled(Typography)`
  &.MuiTypography-body1 {
    font-size: 14px;
    font-weight: 300;
    line-height: normal;
    color: ${TEXT};
  }
`;